// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2d639635","453":"bb0fbe25","732":"4a5eac13","977":"58c7d8a9"}[chunkId] + ".chunk.js";
};